export const setInitialInstituteData = (institute: any): Record<string, any> | undefined => {
  if (Object.keys(institute).length === 0) {
    return undefined;
  }
  const initialData = {
    institute: {
      hospitalName: institute.hospitalName,
      instituteName: institute.name,
      instituteStreet: institute.street,
      instituteHousenumber: institute.housenumber,
      instituteAdditionalAddress: institute.additionalAddress,
      instituteCity: institute.city,
      instituteZip: institute.zip,
      instituteCountry: institute.country,
      instituteTaxID: institute.taxID,

      institutePhone: institute.phone,
      instituteFax: institute.fax,
      instituteEmail: institute.email,
      instituteComments: institute.comments,
      // we have to negate it because the text says "are you a patient care organization"
      isCompany: !institute.isCompany,
      invoicedifferent: !!institute.invoiceName,
      certificatedifferent: !!institute.certificationName,
      invoice: institute.invoiceName ? {
        invoiceName: institute.invoiceName,
        invoiceStreet: institute.invoiceStreet,
        invoiceHousenumber: institute.invoiceHousenumber,
        invoiceZip: institute.invoiceZip,
        invoiceCity: institute.invoiceCity,
        invoiceCountry: institute.invoiceCountry,
      } : undefined,
      certificate: institute.certificationName ? {
        certificationName: institute.certificationName,
        certificationHospitalName: institute.certificationHospitalName,
        certificationStreet: institute.certificationStreet,
        certificationHousenumber: institute.certificationHousenumber,
        certificationZip: institute.certificationZip,
        certificationCity: institute.certificationCity,
        certificationCountry: institute.certificationCountry,
      } : undefined,
      custom: institute.customClearanceUser ? {
        customClearanceUser: institute.customClearanceUser,
        customClearanceContact: institute.customClearanceContact,
        customClearanceEmail: institute.customClearanceEmail,
        eoriNumber: institute.eoriNumber,
      } : undefined,
      forward: institute.forwardAddresses ? {
        email1: institute.forwardAddresses[0],
        email2: institute.forwardAddresses[1],
        email3: institute.forwardAddresses[2],
      } : undefined,
    },
  };

  return initialData;
};

export const parseInsituteData = (institute: Record<string, any>): any => {
  if (!institute) {
    return {};
  }
  let mainInstitute = {
    name: institute.instituteName,
    city: institute.instituteCity,
    zip: institute.instituteZip,
    street: institute.instituteStreet,
    hospitalName: institute.hospitalName || '',
    housenumber: institute.instituteHousenumber,
    additionalAddress: institute.instituteAdditionalAddress,
    country: institute.instituteCountry,
    phone: institute.institutePhone,
    email: institute.instituteEmail,
    fax: institute.instituteFax,
    // we have to negate it because the text says "are you a patient care organization"
    isCompany: !institute.isCompany,
    instituteID: institute.instituteID,
    taxID: institute.instituteTaxID,
    customClearanceUser: institute.custom ? institute.custom.customClearanceUser : undefined,
    customClearanceContact: institute.custom ? institute.custom.customClearanceContact : undefined,
    customClearanceEmail: institute.custom ? institute.custom.customClearanceEmail : undefined,
    eoriNumber: institute.custom ? institute.custom.eoriNumber : undefined,
    comments: institute.instituteComments,
    forwardAddresses: institute.forward ? [
      institute.forward.email1 || '',
      institute.forward.email2 || '',
      institute.forward.email3 || '',
    ] : undefined,
  };

  if (institute.invoicedifferent) {
    const invoiceData = {
      invoiceName: institute.invoice.invoiceName,
      invoiceStreet: institute.invoice.invoiceStreet,
      invoiceHousenumber: institute.invoice.invoiceHousenumber,
      invoiceZip: institute.invoice.invoiceZip,
      invoiceCity: institute.invoice.invoiceCity,
      invoiceCountry: institute.invoice.invoiceCountry,
    };
    mainInstitute = { ...mainInstitute, ...invoiceData };
  }

  if (institute.certificatedifferent) {
    const certification = {
      certificationName: institute.certificate.certificationName,
      certificationHospitalName: institute.certificate.certificationHospitalName || '',
      certificationStreet: institute.certificate.certificationStreet,
      certificationHousenumber: institute.certificate.certificationHousenumber,
      certificationZip: institute.certificate.certificationZip,
      certificationCity: institute.certificate.certificationCity,
      certificationCountry: institute.certificate.certificationCountry,
    };

    mainInstitute = { ...mainInstitute, ...certification };
  }

  return mainInstitute;
};
